import React from 'react';

const uniqueEmailMessage = () => (
  <span>
    Looks like you already have an account <a href={window.loginBaseUrl}>sign in here</a>.
  </span>
);

export default {
  companyMessage: 'What’s the official name of your business?',
  emailMessage: 'You’ll sign into Gusto with this email address.',
  nameMessage: 'Hi, we’re Gusto. What’s your full name?',
  numberEmployeesMessage: 'Have you hired anyone yet? If not, enter "0".',
  phoneMessage: "What's your number? We won't share it with anyone.",
  uniqueEmailMessage: uniqueEmailMessage(),
};
